import { useEffect, useRef } from 'react'
import facebook from './assets/facebook-logo.svg'
import tiktok from './assets/tiktok-logo.svg'
import instagram from './assets/instagram-logo.svg'
import logo from './assets/logo.svg'
import videoMain from './assets/video.mp4'

import './App.css'

function App() {
  const hourRef = useRef(null)
  const minuteRef = useRef(null)
  const secondRef = useRef(null)

  useEffect(() => {
    const updateClock = () => {
      const now = new Date()
      const hours = now.getHours()
      const minutes = now.getMinutes()
      const seconds = now.getSeconds()

      const hourDeg = (hours % 12) * 30 + minutes * 0.5
      const minuteDeg = minutes * 6
      const secondDeg = seconds * 6

      if (hourRef.current) hourRef.current.style.transform = `rotate(${hourDeg}deg)`
      if (minuteRef.current) minuteRef.current.style.transform = `rotate(${minuteDeg}deg)`
      if (secondRef.current) secondRef.current.style.transform = `rotate(${secondDeg}deg)`
    }

    updateClock()
    const interval = setInterval(updateClock, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <>
      <div className='main'>
        <div className='overlay'></div>
        <div className='logo-field'>
          <div className='club-name'>
            <h3>FK Pasvalietis</h3>
            <img src={logo}  alt="ss"/>
          </div>
          <div className='icons-field'>
            <a href='https://www.facebook.com/profile.php?id=61571721026945' target='_blank'><img src={facebook} /></a>
            <a href='https://www.instagram.com/fkpasvalietis' target='_blank'> <img src={instagram} /></a>
            <a href='https://www.tiktok.com/@fkpasvalietis' target='_blank'> <img src={tiktok} /></a>
          </div>
        </div>

        <div className='info-field'>
          <div className='text-field'>
            <h3>Mūsų nauja svetainė</h3>
            <h1>JAU GREITAI!</h1>
            <h3>Laukite naujienų!</h3>
          </div>

          <div className="clock">
            <div className="time">
              {/* čia laikrodžio skaičiai, be keitimų */}
              {[...Array(12)].map((_, i) => (
                <section key={i} id={['one','two','three','four','five','six','seven','eight','nine','ten','eleven','twelve'][i]}></section>
              ))}
            </div>

            <div className="pointer">
              <section id="middle"></section>
              <section id="small" ref={hourRef}></section>
              <section id="large" ref={minuteRef}></section>
              <section id="second" ref={secondRef}></section>
            </div>
          </div>
        </div>

        <video src={videoMain} autoPlay loop muted />
        <div className='footer-field'>
          <p>Visos teisės saugomos © 2024 Futbolo klubas Pasvalietis</p>
        </div>
      </div>
    </>
  )
}

export default App
